import React, { forwardRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { GridActionsCellItem } from "@mui/x-data-grid";
import * as Icons from "react-bootstrap-icons";
import Inputer from "Utils/Helpers/Inputer";
import { useSetState } from "Utils/Helpers/Hooks";
import { Grid2 } from "@mui/material";
import MButton from "Utils/Helpers/MButton";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { useDispatch } from "react-redux";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { setUsersData } from "../../../../../Redux/slices/mngrSlice";
import { put_user } from "http/components/User";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function UsersEdit({ row }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [controls, setControls] = useSetState({
      name: {
        display: true,
        label: "Name",
        type: "text",
        multiLine: false,
        placeholder: "Name",
        value: "",
        validation: false,
      },
      username: {
        display: true,
        label: "Username",
        type: "text",
        multiLine: false,
        placeholder: "Username",
        value: "",
        validation: false,
      },
      password: {
        display: true,
        label: "Password",
        type: "password",
        multiLine: false,
        placeholder: "Password",
        value: "",
        validation: false,
      },
    });

  const onEnter = () => {
    setControls({ name: { value: row.name, validation: true } });
    setControls({ username: { value: row.username, validation: true } });
    setControls({ password: { value: row.password, validation: true } });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value, validation } });
  };

  const setShowDialog = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const onSubmit = async () => {
    const { name, username, password } = controls;
    if (name.validation && username.validation && password.validation) {
      dispatch(HandleLoading(true));
      const response = await put_user({
        id: row.id,
        name: name.value,
        username: username.value,
        password: password.value,
      });
      if (CheckApiStatus(response)) {
        dispatch(setUsersData(true));
        enqueueSnackbar("Edit Success", { variant: "success" });
      }
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Enter data correctly", { variant: "error" });
    }
  };

  return (
    <>
      <GridActionsCellItem
        icon={<Icons.Pencil size={16} />}
        label="Edit"
        onClick={setShowDialog}
        className="btn-manager btn-edit"
      />
      {show && (
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={"xs"}
          onClose={handleClose}
          TransitionProps={{ onEnter: onEnter }}
          aria-describedby="alert-dialog-edit"
        >
          <DialogTitle>{`Edit (${row.title})`}</DialogTitle>
          <DialogContent>
            {show && (
              <Grid2 container spacing={2}>
                {Object.keys(controls).map((key, index) => {
                  return (
                    <Grid2
                      size={{ xs: 12 }}
                      key={key + index}
                    >
                      {["text", "password"].includes(controls[key].type) && (
                        <Inputer
                          id={key}
                          setValue={setValue.bind(this)}
                          value={controls[key].value}
                          label={controls[key].label}
                          placeholder={controls[key].placeholder}
                          type={controls[key].type}
                          multiLine={controls[key].multiLine}
                        />
                      )}
                    </Grid2>
                  );
                })}
              </Grid2>
            )}
          </DialogContent>
          <DialogActions>
            <MButton
              label={"Close"}
              color="secondary"
              onClick={handleClose}
              className="flex-grow-1"
            />
            <MButton
              label={"Update"}
              className="flex-grow-1"
              onClick={onSubmit}
            />
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
